import type { paths } from "@/api-schema";

export const VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE = "vehicle-valuation-price-adjustment" as const;
export const VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH =
  `/v1/${VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE}` as const;
export const VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_OPERATION = "search" as const;
export const VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH =
  `${VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH}/${VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_OPERATION}` as const;

export type VehicleValuationPriceAdjustmentCreateBody =
  paths[typeof VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentCreateResponse =
  paths[typeof VEHICLE_VALUATION_PRICE_ADJUSTMENT_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentUpdateBody =
  paths["/v1/vehicle-valuation-price-adjustment/{uuid}"]["patch"]["requestBody"]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentUpdateResponse =
  paths["/v1/vehicle-valuation-price-adjustment/{uuid}"]["patch"]["responses"][200]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentSearchBody =
  paths[typeof VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH]["post"]["requestBody"]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentSearchParameters =
  paths[typeof VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH]["post"]["parameters"]["query"];

export type VehicleValuationPriceAdjustment =
  paths["/v1/vehicle-valuation-price-adjustment/{uuid}"]["get"]["responses"][200]["content"]["application/json"];

export type VehicleValuationPriceAdjustmentSearchResponse =
  paths[typeof VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH]["post"]["responses"][200]["content"]["application/json"];
